<template>
    <div class="rently-quantity-field range-container">
        <span @click="decrement">-</span>
        <input type="text" disabled="true" v-bind:value="value">
        <span @click="increment">+</span>
    </div>
</template>

<script>
    export default {
        props: ['value'],
        methods:{
            increment(){
                let newValue = this.value + 1;
                this.$emit('input', newValue)
            },
            decrement(){
                if(this.value > 1){
                    let newValue = this.value -1;
                    this.$emit('input', newValue)
                }
            }
        }
    }
</script>

<style lang="scss">
    .rently-quantity-field{
        span{
            width: 35px;
            height: 35px;
            line-height: 35px;
            font-size: 20px;
            border: 1px solid #eee;
            display: inline-block;
            text-align: center;
        }
        input[type='text']{
            width: 35px;
            height: 35px;
            border: 1px solid #eee;
            text-align: center;
        }
    }
</style>